module.exports = __webpack_public_path__ + "static/img/autumn_liPic.75002585.png";